import { render, staticRenderFns } from "./VStarRating.vue?vue&type=template&id=4d68df85&scoped=true"
import script from "./VStarRating.vue?vue&type=script&lang=js"
export * from "./VStarRating.vue?vue&type=script&lang=js"
import style0 from "./VStarRating.vue?vue&type=style&index=0&id=4d68df85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68df85",
  null
  
)

export default component.exports